import rootSettings from '../../Styles/rootSettings';

const styles = {
  ...rootSettings,
};

export default styles;
